import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";


const fetchAssetNo = async () => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const [responseFems, responseBems] = await Promise.all([
            axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config),
            axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config)
        ]);
        const combinedData = [...responseFems.data, ...responseBems.data];
        return combinedData;
    }
    catch (error) {
        console.log(error);
    }
};

const fetchWorkOrderNo = async () => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const [responseFems, responseBems] = await Promise.all([
            axios.get(`${FemsGraph}/api/ScheduledCorrectiveMaintenance/GetSCMWorkOrderNoFetchList/${facilityId},1,100000`, config),
            axios.get(`${BemsGraph}/api/ScheduledCorrectiveMaintenance/GetSCMWorkOrderNoFetchList/${facilityId},1,100000`, config)
        ]);
        const combinedData = [...responseFems.data, ...responseBems.data];
        return combinedData;
    }
    catch (error) {
        console.log(error);
    }
};
const lovOptions = async () => {
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.get(`${FemsGraph}/api/CommonLov/GetCommonLovList/`, config);

        return response?.data;
    } catch (error) {
        console.log(error);
    }
};

const fetchTypes = async (selectedCategory) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        // const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${selectedCategory}`, config);
        const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${selectedCategory}`, config);

        return response?.data;

    } catch (error) {
        console.error('Error fetching types:', error);
    }
};

const createBasicDetails = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;


        const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}schcorrectivemaintenanceheaders`, payload, config);
        return response.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const workordernoGeneration = async (categoryType) => {
    const facilityId = getFacilityId('facilityId');
    const checkCode = categoryType === "scheduled" ? "scheduledworkorderheaders" : "MWR";

    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetails/${facilityId}/${checkCode}/${token}`, config);

        return response.data;
    } catch (error) {
        console.log(error);
    }
};


const getBasicDetails = async (serviceType, basicdetailsdataId, categoryType) => {
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkCategory = categoryType === "scheduled" ? "scheduledworkorderheaders" : "unscheduledworkorderheaders";

        const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${basicdetailsdataId}`, config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const updateBasicDetails = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}schcorrectivemaintenanceheaders/${payload?.id}`, payload, config);
        return response.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const getWorkOrderSummary = async (serviceType, scmId) => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetSCMWorkOrderId/${facilityId},${scmId},${token}`, config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const fetchItemCodeoptions = async (serviceType) => {
    const facilityId = getFacilityId('facilityId');
    const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/GetWorkOrderItemDetailsFetchList/${facilityId},1,100000`, config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const addItemPartCode = async (serviceType, payload, categoryType) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const checkCategory = categoryType === "Scheduled" ? "scheduledwopartsreplacedetails" : "unscheduledwopartsreplacedetails";
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}${checkCategory} `, payload, config);

        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const getItemPartCode = async (serviceType, workorderId) => {
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetSCMwopartsreplaceList/${workorderId},1,2000`, config);

        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const getRepairDetails = async (serviceType, assessmentId) => {
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        // Make the API request
        const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetSCMworepairdetailsList/${assessmentId},1,1000`, config);

        // Return the data from the API call to the calling function
        return response.data;
    } catch (error) {
        console.error('Error fetching repair details:', error);
        // Optionally throw the error to handle it in the calling function
        throw error;
    }
};


const updateItemPartCode = async (serviceType, payload, workorderId) => {

    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}schcorrectivepartsreplacedetails/${workorderId}`, payload, config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const deleteItemPartCode = async (serviceType, id) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.delete(`${checkGraph}/api/${checkFEMorBEM}schcorrectivepartsreplacedetails/${id}`, config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};


const addCompletionInfo = async (serviceType, payload) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}schcorrectivecompletiondetails`, payload, config);


        return response.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const updateCompletionInfo = async (serviceType, id, payload) => {


    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}schcorrectivecompletiondetails/${id}`, payload, config);


        return response.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const fetchEmployeeDetails = async () => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}`, config);

        return response.data;
    } catch (error) {
        console.log(error);
    }
};


const fetchTaskCode = async (serviceType, workGroupId) => {
    const facilityId = getFacilityId('facilityId');
    const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/GetWorkOrderTaskCodeFetchList/${facilityId},${workGroupId},1,100000`, config);
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
};

const fetchVendorDetails = async () => {
    const companyId = getcompanyId('companyId');
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?Size=100000`, config);

        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const addAssessmentsDetails = async (serviceType, payload) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };
        const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}schcorrectiveassessmentheaders`, payload, config);

        return response.data;

    } catch (error) {
        console.log(error);
        return error;
    }
};

const updateAssessmentsDetails = async (serviceType, payload) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}schcorrectiveassessmentheaders/${payload?.id}`, payload, config);
        return response.data;

    } catch (error) {
        console.log(error);
        return error;
    }
};


const updateAssessmentsDetailsInWebForm = async (serviceType, payload) => {
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const addRepairTracker = async (serviceType, payload) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}schcorrectiverepairdetails`, payload, config);

        return response.data;

    } catch (error) {
        console.log(error);
    }
};

const updateRepairTracker = async (serviceType, payload, assementsId) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}schcorrectiverepairdetails/${assementsId}`, payload, config);

        return response.data;

    } catch (error) {
        console.log(error);
    }
};

const deleteRepairTracker = async (serviceType, id) => {
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
            },
        };

        const response = await axios.delete(`${checkGraph}/api/${checkFEMorBEM}schcorrectiverepairdetails/${id}`, config);

        return response.data;

    } catch (error) {
        console.log(error);
    }
};
const workorderStatusValue = async (serviceType, WorkOrderId, status, percentage) => {
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    try {
        const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, // Attach bearer token to request header
                "Content-Type": "application/json" // Ensure proper content type
            },
        };
        const response = await axios.put(`${checkGraph}/api/ScheduledCorrectiveMaintenance/UpdateWorkOrderStatus/${WorkOrderId},${status},${percentage}`,{}, config);
        return response.data;

    } catch (error) {
        console.log(error);
    }
};

const scmList = async (serviceType, pageIndex, pageSize, filterModel, sortModel) => {
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetSCMWorkOrderList/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`, config);
        return response;
    } catch (error) {
        console.log(error);
    }
}

const scmListExport = async (serviceType,  filterModel, sortModel) => {
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetScmWorkOrderListExport/${facilityId}?filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`, config);
        return response;
    } catch (error) {
        console.log(error);
    }
};

const sendVendorEmail = async (serviceType, payload) => {
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  
    try {
      const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Attach bearer token to request header
        },
      };
  
      const response = await axios.post(`${checkGraph}/api/WorkOrderEmailSend`, payload, config);
      return response.data;
  
    } catch (error) {
      console.log(error);
    }
  };


const ScmRepositry = {
    fetchAssetNo,
    getWorkOrderSummary,
    createBasicDetails,
    workordernoGeneration,
    updateBasicDetails,
    getBasicDetails,
    fetchWorkOrderNo,
    lovOptions,
    fetchTypes,
    fetchItemCodeoptions,
    addItemPartCode,
    getItemPartCode,
    updateItemPartCode,
    deleteItemPartCode,
    addCompletionInfo,
    updateCompletionInfo,
    fetchEmployeeDetails,
    fetchTaskCode,
    addAssessmentsDetails,
    updateAssessmentsDetails,
    updateAssessmentsDetailsInWebForm,
    addRepairTracker,
    deleteRepairTracker,
    updateRepairTracker,
    fetchVendorDetails,
    workorderStatusValue,
    getRepairDetails,
    scmList,
    scmListExport,
    sendVendorEmail
};

export default ScmRepositry;